// @flow
import { createReducer } from "reduxsauce";
import Types from "../actions/Types";

// Init State
export const INITIAL_STATE = {
  inventoryStock: null,
  errorMessage: null,
  successMessage: null,
  isLoading: false
};

/* Generic error message */
const genericError = "Something went wrong";

/* Get inventoryStock */
export const getInventoryStock = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    isLoading: action.query.indexOf("is_export") === -1,
    isExportLoading: action.query.indexOf("is_export") !== -1
  };
};

export const getInventoryStockSuccess = (state = INITIAL_STATE, action) => {
  const val = {
    ...state,
    isLoading: false,
    isExporting: false
  };
  if (!state.isExportLoading) {
    val.inventoryStock = action.inventoryStock;
  }
  return val;
};

export const getInventoryStockFailure = (state = INITIAL_STATE, action) => ({
  ...state,
  isLoading: false,
  isExporting: false,
  errorMessage: action.error || genericError
});

/* getInventoryWarehouse */
export const getInventoryWarehouse = (state = INITIAL_STATE) => {
  return {
    ...state,
    isLoading: true
  };
};

export const getInventoryWarehouseSuccess = (state = INITIAL_STATE, action) => {
  return {
    ...state,
    warehouses: action.warehouses,
    isLoading: false
  };
};

export const getInventoryWarehouseFailure = (
  state = INITIAL_STATE,
  action
) => ({
  ...state,
  isLoading: false,
  errorMessage: action.error || genericError
});

const ACTION_HANDLERS = {
  [Types.GET_INVENTORY_STOCK]: getInventoryStock,
  [Types.GET_INVENTORY_STOCK_SUCCESS]: getInventoryStockSuccess,
  [Types.GET_INVENTORY_STOCK_FAILURE]: getInventoryStockFailure,
  [Types.GET_INVENTORY_WAREHOUSE]: getInventoryWarehouse,
  [Types.GET_INVENTORY_WAREHOUSE_SUCCESS]: getInventoryWarehouseSuccess,
  [Types.GET_INVENTORY_WAREHOUSE_FAILURE]: getInventoryWarehouseFailure
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);



// WEBPACK FOOTER //
// ./src/reducers/InventoryReducer.js